import React from 'react';
//Components
import { Col, Row } from "antd";
//Custom Components
import { CustomImage } from "../../../../components";
//Configurations
import { HDR_ASSETS_CONFIG as assets } from "../../../../assets";

const HDRDelinquenciesDistribution = () => {

  const description =
    <div>
      Delinquencies Distribution <br/>
      Shows the distribution of delinquent Loans via a pie chart, grouped by the number of days in delay. The user can
      choose to change the type of chart.
    </div>

  return (
    <Row style={{paddingLeft: '20px'}}>
      <Col sm={24}>
        <CustomImage
          description={description}
          alt="Default Distribution"
          src={assets.images.HDRModule.delinquenciesDistribution}
        />
      </Col>
    </Row>
  );
};

export default HDRDelinquenciesDistribution;